import { Badge, Group, ThemeIcon } from "@mantine/core";
import { statusColor } from "../pages/customer/vmUtils.js";

/**
 * Status dot + label, consistent with the cloud-console idiom used
 * across DigitalOcean / Hetzner / Vultr.
 *
 * - running  : green, solid
 * - stopped  : gray, solid
 * - paused   : amber, solid
 * - creating : blue, animated pulse
 * - orphaned : red, solid
 * - unknown  : blue, solid
 *
 * The dot's animation is injected via a single keyframe declaration
 * that lives in index.html (so it isn't duplicated per-render).
 *
 * Color mapping comes from vmUtils.statusColor — single source of
 * truth shared with the legacy Dashboard code path.
 */
export function StatusPill({ status, label }: { status: string; label?: string }) {
  const color = statusColor(status);
  const animated = status === "creating";
  return (
    <Group gap={6} wrap="nowrap">
      <ThemeIcon
        size={10}
        color={color}
        variant="filled"
        radius="xl"
        style={{
          padding: 0,
          minWidth: 10,
          height: 10,
          animation: animated ? "proxvps-pulse-dot 1.4s ease-in-out infinite" : undefined,
        }}
      />
      <Badge color={color} variant="light" tt="capitalize" size="sm">
        {label ?? status}
      </Badge>
    </Group>
  );
}
